import mapboxgl from 'mapbox-gl';

// domain/valueObjects/BoundingBox.ts
export class BoundingBox {
  constructor(
    public readonly swLat: number,
    public readonly swLng: number,
    public readonly neLat: number,
    public readonly neLng: number,
  ) {
    if (swLat > neLat) throw new Error('SW lat must be <= NE lat');
    if (swLng > neLng) throw new Error('SW lng must be <= NE lng');
  }
  toQuery() {
    return `${this.swLat},${this.swLng},${this.neLat},${this.neLng}`;
  }

  toLngLatBounds() {
    return new mapboxgl.LngLatBounds(
      new mapboxgl.LngLat(this.swLng, this.swLat),
      new mapboxgl.LngLat(this.neLng, this.neLat)
    );
  }
}
